// Раздел «Отчётность»: отчёты по списку судов. Первый и пока единственный —
// пропуски АИС. Пункт в рельсе виден только кабинету с признаком
// `ais_reports` (`layout/nav.ts`); ручки закрыты тем же признаком на сервере.

import { useT } from '../i18n'
import { AisGapsReport } from './AisGapsReport'

export function ReportsPage() {
  const t = useT()
  return (
    <div className="h-full overflow-y-auto">
      <div className="mx-auto max-w-7xl p-6">
        <h1 className="text-xl font-semibold tracking-tight text-foam">{t('reports.title')}</h1>
        <div className="mb-5 mt-3 flex gap-4 border-b border-hull text-sm">
          <span className="-mb-px border-b-2 border-sonar pb-2 text-foam">{t('reports.aisGaps.title')}</span>
        </div>
        <AisGapsReport />
      </div>
    </div>
  )
}
